import React from 'react';
import AvatarGroupBuilder from '../components/AvatarGroupBuilder';

export default function CreateAvatarGroup() {
  return <AvatarGroupBuilder mode="create" />;
}
